

<template>
  <div class="sidebar-container" :class="{'is-active':isCollapse}">
      <logo :isCollapse="isCollapse"></logo>
      <div class="out-menu">
        <div class="inner-menu">
          <el-menu unique-opened = "true"
                   :default-active="nowTagValue"
                   mode="vertical"
                   class="el-menu-vertical-demo"
                   :collapse="isCollapse"
                   :default-openeds="opened"
          >
            <sidebar-item :menuData="menu" :isCollapse="isCollapse"></sidebar-item>
          </el-menu>
        </div>
      </div>
  </div>
</template>

<script>
import { setUrlPath } from '@/util/util';
import { mapGetters } from 'vuex';
import SidebarItem from './sidebarItem';
import logo from './logo';
import platformMenus from '@/menus/demo/demo';
import homeMenus from '@/menus/home/home';
import cusmanage from '@/menus/cusmanage/cusmanage';
import usermanage from '@/menus/usermanage/usermanage';
import drivermanage from '@/menus/driver/driver';
import ordermanage from '@/menus/order/order';
import apprmanage from '@/menus/apprmanage/apprmanage';
import sysmanage from '@/menus/sys/index';
import projectmanage from '@/menus/project/project';
import { deepCopy, getAuthorizedMenu } from '@/util/util';
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

export default {
  name: 'sidebar',
  components: { SidebarItem },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      localMenu: [],
    };
  },
  created() {
    this.isLocal = process.env.VUE_APP_LOCAL_DEVELOPMENT
    if(this.screenWidth <= 1400) {
      this.$store.commit('SET_COLLAPSE');
    }
    let newMenusArray =homeMenus.concat(platformMenus);
    newMenusArray = newMenusArray.concat(usermanage)
    newMenusArray = newMenusArray.concat(cusmanage)
    newMenusArray = newMenusArray.concat(drivermanage)
    newMenusArray = newMenusArray.concat(ordermanage)
    newMenusArray = newMenusArray.concat(apprmanage)
    newMenusArray = newMenusArray.concat(sysmanage)
    newMenusArray = newMenusArray.concat(projectmanage)
    this.localMenu = newMenusArray
    let menuData = deepCopy(newMenusArray)
    const menuSet = this.pms.map(item=>{
      return item.permission;
    })
    let authorizedMenu = getAuthorizedMenu(menuData, menuSet);
    this.$store.commit('SET_MENU', authorizedMenu);
    //this.$store.commit('SET_MENU',menuData);
   // this.initWebSocket();
  },
  computed: {
    ...mapGetters(['isCollapse','pms', 'menu','opened','memberInfo', 'accessToken']),
    nowTagValue() {
      return setUrlPath(this.$route);
    },
  },
  mounted() {

  },
  methods: {


  },
};
</script>
<style lang="scss" scoped>
.out-menu{
}
.inner-menu{
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 180px;
}
/* for Chrome */
.inner-menu::-webkit-scrollbar {
  display: none;
}




/*.sidebar-container.is-active{*/
/*  width: 80px !important;*/
/*}*/
</style>
<style>
  /*.el-menu--popup-right-start{*/
  /*  margin-left: 1px !important;*/
  /*}*/
</style>
